
module.config(function($stateProvider) {
    $stateProvider.state('settings.initiativeTypes', {
        url: '/initiative-types',
        permission: 'editInitiativeTypes',
        templateUrl: 'settings/initiativeTypes',
        resolve: {
            urlBuilder: function(ApiUrl) {
                return ApiUrl.partial('initiatives', 'type');
            },
            initiativeTypes: function($http, urlBuilder) {
                return $http.get(urlBuilder()).then(function(response) {
                    return response.data.types;
                });
            },
        },
        controller: module.cC({
            name: 'InitiativeTypeSettingsController',
            inject: ['$scope', '$http', 'urlBuilder', 'initiativeTypes',
                     'Notifications'],
            data: {
                'initiativeTypes': 'initiativeTypes',
                'colors': "['red', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink']",
            },

            methods: {
                openForm: function(init) {
                    if (init && init.id) {
                        this.$.formData = angular.copy(init);
                        this.$.formData.$new = false;
                        this.$.formData.$name = init.name;
                        this.$.formData.$type = init;
                    } else {
                        this.$.formData = {enabled: false};
                        this.$.formData.$new = true;
                    }
                },
                closeForm: function() {
                    delete this.$.formData;
                },

                saveForm: function(form, data) {
                    if (form.$invalid) return;
                    var copy = angular.copy(data);

                    if (data.$new) {
                        delete copy.$new;
                        this.$http.post(this.urlBuilder(), copy).then(
                            this._saveSuccess.bind(this, false),
                            this._saveError.bind(this, false)
                        );
                    } else {
                        delete copy.$new;
                        delete copy.$name;
                        delete copy.$type;
                        delete copy.id;
                        delete copy.active;
                        delete copy.total;
                        this.$http.put(this.urlBuilder(data.id), copy).then(
                            this._saveSuccess.bind(this, data.$type),
                            this._saveError.bind(this, data.$type)
                        );
                    }
                },

                _saveSuccess: function(existing, response) {
                    if (existing) {
                        angular.copy(response.data.type, existing);
                        this.Notifications.success(existing.name + " was updated.")
                    } else {
                        this.$.initiativeTypes.push(response.data.type);
                        this.Notifications.success(response.data.name +
                            " was created successfully.");
                    }
                    this.closeForm();
                },

                _saveError: function(existing, response) {
                    this.Notifications.canned('form_errors');
                },
            }
        })
    });
});


